import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import { StrapiSingle } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import OrderRequest from '../../types/api/order-request'

export const orderRequestsApi = createApi({
    reducerPath: 'orderRequestsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['OrderRequests'],
    endpoints: builder => ({
        getOrderRequest: builder.query<Strapi<OrderRequest>, EndpointQueryParameters | void>({
            query: getQuery('/order-requests'),
            providesTags: ['OrderRequests'],
        }),
        getMyOrderRequests: builder.query<Strapi<OrderRequest>, EndpointQueryParameters | void>({
            query: getQuery('/order-requests/my'),
            providesTags: ['OrderRequests'],
        }),
        getOrderRequestByDocId: builder.query<
            StrapiSingle<OrderRequest>,
            [string, EndpointQueryParameters] | [string]
        >({
            query: ([docId, params]) => getQuery(`/order-requests/${docId}`)(params),
            providesTags: ['OrderRequests'],
        }),
        createOrderRequest: builder.mutation<
            StrapiSingle<OrderRequest>,
            StrapiCreate<OrderRequest>
        >({
            query: body => ({
                url: '/order-requests',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['OrderRequests'],
        }),
        updateOrderRequest: builder.mutation<
            StrapiSingle<OrderRequest>,
            StrapiUpdate<OrderRequest>
        >({
            query: ({ docId, body }) => ({
                url: `/order-requests/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['OrderRequests'],
        }),
    }),
})

export const {
    useGetOrderRequestQuery,
    useGetMyOrderRequestsQuery,
    useLazyGetOrderRequestQuery,
    useGetOrderRequestByDocIdQuery,
    useCreateOrderRequestMutation,
    useUpdateOrderRequestMutation,
} = orderRequestsApi
